import type { ComponentProps, FC } from 'react'

const Notification: FC<ComponentProps<'div'>> = ({
  className,
  children,
  ...props
}) => {
  const classes = [
    'fixed bottom-4 w-full flex flex-row justify-center z-50 transition-transform duration-1000 ease-out',
    className,
  ]

  return (
    <div className={classes.join(' ')} {...props}>
      <div className="inline-flex w-[545px] items-center justify-center gap-2 rounded-[32px] bg-[#27272A] p-2 text-white shadow-2xl">
        {children}
      </div>
    </div>
  )
}

export default Notification
